import { useEffect, useRef, useState } from "react";
import { ChevronDown, Globe } from "lucide-react";
import { useT, LANGS } from "@/i18n";

export default function LangToggle({ variant = "ghost" }) {
  const { lang, setLang } = useT();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  useEffect(() => {
    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [open]);

  const base =
    variant === "outline"
      ? "border border-zinc-200 bg-white hover:bg-zinc-50"
      : "hover:bg-zinc-100";

  return (
    <div className="relative" ref={wrapRef} data-testid="lang-toggle-wrap">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="lang-toggle"
        aria-label="Change language"
        className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-bold text-zinc-800 transition-colors ${base}`}
      >
        <Globe className="w-3.5 h-3.5 text-zinc-500" />
        <span className="uppercase">{current.label}</span>
        <ChevronDown className={`w-3 h-3 text-zinc-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul
          role="listbox"
          data-testid="lang-menu"
          className="absolute right-0 mt-1 w-44 bg-white border border-zinc-200 rounded-md shadow-lg py-1 z-50"
        >
          {LANGS.map((l) => (
            <li key={l.code}>
              <button
                type="button"
                onClick={() => { setLang(l.code); setOpen(false); }}
                data-testid={`lang-option-${l.code}`}
                className={`w-full flex items-center gap-2 px-3 py-2 text-sm text-left hover:bg-zinc-50 ${
                  l.code === lang ? "bg-amber-50 text-amber-900 font-bold" : "text-zinc-700"
                }`}
              >
                <span className="text-base leading-none">{l.flag}</span>
                <span className="flex-1">{l.name}</span>
                <span className="text-[10px] font-mono text-zinc-400 uppercase">{l.code}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
